import { TFunction } from "i18next";
import { RefinementChipEventType } from "../hooks/useRefinementChips";

// PMA-COCK-183: body-part chips are retired for every Shot dispatch (client
// decision, 2026-09-11) — kept unreachable rather than deleted, same as
// before. PMA-COCK-185: the goal-frame capture itself also moved out of
// this panel (to `GoalPlacementOverlay.tsx`, mounted over the pitch), so a
// Shot's `eventType` now has literally nothing left to show here — no
// chips, no frame, no Skip — and the panel renders nothing at all for Shot,
// unconditionally (not just for a non-eligible one, per PMA-COCK-183's own
// earlier rule). Duel is completely unaffected.
const DUEL_CHIPS = ["Ground", "Aerial"] as const;

interface RefinementChipPanelProps {
  eventType: RefinementChipEventType;
  onChipTap: (chip: string) => void;
  onDismiss: () => void;
  t: TFunction<"logger">;
}

const RefinementChipPanel = ({
  eventType,
  onChipTap,
  onDismiss,
  t,
}: RefinementChipPanelProps) => {
  // PMA-COCK-185: the goal-frame placement moved to `GoalPlacementOverlay`,
  // mounted over the pitch instead of this post-shot panel — see
  // `ActionStage.tsx`'s `fieldOverlay`. Shot never has anything left to
  // show here, so the whole panel renders nothing at all.
  if (eventType === "Shot") {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow p-3 flex flex-col gap-2">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        {t(`refinementChips.title_${eventType}`)}
      </p>
      <div className="flex flex-wrap gap-2">
        {DUEL_CHIPS.map((chip) => (
          <button
            key={chip}
            data-testid={`chip-${chip}`}
            onClick={() => onChipTap(chip)}
            className="px-3 py-1.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 hover:bg-indigo-200 active:bg-indigo-300 transition-colors"
          >
            {t(`refinementChips.${chip.replace(" ", "_")}`)}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="chip-dismiss"
          onClick={onDismiss}
          className="px-3 py-1.5 rounded-full text-sm font-medium bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors"
        >
          {t("refinementChips.skip")}
        </button>
      </div>
    </div>
  );
};

export default RefinementChipPanel;
